import { type ComponentProps, useId } from 'react';

type IconProps = ComponentProps<'svg'>;

export const CloseIcon = ({ className, ...props }: IconProps) => (
    <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M20.7063 19.2945C21.0969 19.6852 21.0969 20.318 20.7063 20.7086C20.5125 20.9039 20.2563 21.0008 20 21.0008C19.7437 21.0008 19.4881 20.9031 19.2931 20.7078L16 17.4164L12.7072 20.707C12.5119 20.9039 12.2559 21.0008 12 21.0008C11.7441 21.0008 11.4884 20.9039 11.293 20.707C10.9023 20.3164 10.9023 19.6836 11.293 19.293L14.5867 15.9992L11.293 12.707C10.9023 12.3164 10.9023 11.6836 11.293 11.293C11.6836 10.9023 12.3164 10.9023 12.707 11.293L16 14.5883L19.2937 11.2945C19.6844 10.9039 20.3172 10.9039 20.7078 11.2945C21.0984 11.6852 21.0984 12.318 20.7078 12.7086L17.4141 16.0023L20.7063 19.2945Z"
            fill="#212529"
        />
    </svg>
);

export const SuccessIcon = ({ className, ...props }: IconProps) => (
    <svg className={className} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect width="48" height="48" rx="24" fill="#d6ebea" />
        <path
            d="M34.5 18C34.5 18.3838 34.3535 18.7678 34.0605 19.0603L22.0605 31.0603C21.7688 31.3547 21.3844 31.5 21 31.5C20.6156 31.5 20.2322 31.3535 19.9397 31.0605L13.9397 25.0605C13.6467 24.7688 13.5 24.3844 13.5 24C13.5 23.1431 14.2008 22.5 15 22.5C15.3838 22.5 15.7678 22.6465 16.0603 22.9395L21 27.8812L31.9406 16.9406C32.2312 16.6467 32.6156 16.5 33 16.5C33.8016 16.5 34.5 17.1422 34.5 18Z"
            fill="#117069"
        />
    </svg>
);

export const ExpandedCloseIcon = ({ className, ...props }: IconProps) => {
    const clipPathId = useId();

    return (
        <svg className={className} width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="0.5" y="0.5" width="63" height="63" rx="31.5" fill="#117069" />
            <g clipPath={`url(#${clipPathId})`}>
                <path
                    d="M39.0594 36.9418C39.6453 37.5277 39.6453 38.477 39.0594 39.0629C38.7688 39.3559 38.3844 39.5012 38 39.5012C37.6156 39.5012 37.2322 39.3547 36.9397 39.0617L32 34.1246L27.0608 39.0605C26.7678 39.3559 26.3839 39.5012 26 39.5012C25.6161 39.5012 25.2327 39.3559 24.9395 39.0605C24.3535 38.4746 24.3535 37.5254 24.9395 36.9395L29.8801 31.9988L24.9395 27.0605C24.3535 26.4746 24.3535 25.5254 24.9395 24.9395C25.5254 24.3535 26.4746 24.3535 27.0605 24.9395L32 29.8824L36.9406 24.9418C37.5266 24.3559 38.4758 24.3559 39.0617 24.9418C39.6477 25.5277 39.6477 26.477 39.0617 27.0629L34.1211 32.0035L39.0594 36.9418Z"
                    fill="white"
                />
            </g>
            <rect x="0.5" y="0.5" width="63" height="63" rx="31.5" stroke="#117069" />
            <defs>
                <clipPath id={clipPathId}>
                    <rect width="15" height="24" fill="white" transform="translate(24.5 20)" />
                </clipPath>
            </defs>
        </svg>
    );
};
